<template>
  <Header></Header>
  <SideBar></SideBar>

  <Body pageTitle="General Statistic">
    <template v-slot:body>
      <div class="filter-container d-flex flex-wrap flex-auto" ref="container">
        <DatePicker class="m-1 date-picker-left" :value="query.date" @change="query.date = $event" range multi-calendars format="YYYY-MM-DD" :preset-dates="presetDates" placeholder="Date Range" style="max-width: 250px" />
        <Select class="m-1" source="user/search" type="auto" field="order.user_read" placeholder="Seller" v-model="query.user_id"></Select>
        <Select class="m-1" source="sale-account/search" placeholder="Sale Account" v-model="query.account_id"></Select>
        <button class="btn btn-light m-1" @click.prevent="submit">Search</button>
      </div>
      <LayoutBuilder :config="{ layout: this.data || [], query, components }" />
    </template>
  </Body>
</template>

<script>
import moment from 'moment'
import Event from '@/helper/event.js'
import Header from '@/layouts/Header.vue'
import SideBar from '@/layouts/SideBar.vue'
import Body from '@/layouts/Body.vue'
import LayoutBuilder from '@/components/LayoutBuilder.vue'
import DatePicker from '@/components/DatePicker.vue'
export default {
  components: {
    Header,
    SideBar,
    Body,
    LayoutBuilder,
    DatePicker
  },
  mixins: [Event],
  data() {
    return {
      query: {
        date: [moment().subtract(6, 'days').startOf('day').format('YYYY-MM-DD'), moment().endOf('day').format('YYYY-MM-DD')],
        user_id: null,
        account_id: null
      },
      presetDates: ['Today', 'Yesterday', 'This Week', 'Last Week', '7 Days Ago', 'This Month', 'Last Month', '30 Days Ago', '3 Months Ago', '90 Days Ago', 'This Year']
    }
  },
  computed: {
    storeId() {
      return 'main'
    },
    getUri() {
      return `order/general-statistic`
    },
    data() {
      return this.store.getter('')
    },
    components() {
      let components = this.$util.requiresOrNull('/Order/GeneralStatistic/Items/.*')
      let results = {}
      Object.entries(components).forEach(([key, component]) => {
        results[`${key.split('/').pop().replace('.vue', '')}`] = component
      })
      return results
    }
  },
  methods: {
    setUpData({ status, data }) {
      if (status != 'success') return
      this.store.commit('', data)
    },
    submit() {
      this.fetchData(this.query, {
        $el: this.$refs.container
      })
    }
  }
}
</script>
<style lang="scss">
.page-order-general-statistic {
  .grid-container {
    .grid-item {
      background: #fff;
      padding: 15px;
      position: relative;
    }
  }
  .title {
    font-size: 16px;
    font-weight: 500;
    color: #384551;
  }
  .filter-container {
    background: #fff;
    padding: 10px;
    position: relative;
    border-radius: var(--border-radius, 0.25rem);
    margin-bottom: 20px;
    justify-content: center;
    > * {
      max-width: 200px;
    }
  }
}
</style>
